import React, { useState } from 'react';
import { Admin } from '../../../types';
import DeleteIcon from '../icons/deleteIcon';
import { avatarColor, initialOf } from '../../common/avatar';
import style from './adminItem.module.css';

const CopyIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

interface AdminItemProps {
  admin: Admin;
  index: number;
  openModal: (admin: Admin) => void;
}

const AdminItem: React.FC<AdminItemProps> = ({ admin, index, openModal }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!admin.email) return;
    navigator.clipboard?.writeText(admin.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={style.adminItem}>
      <div className={style.numberText}>{index + 1}</div>
      <div className={style.firsInfo}>
        {admin.avatarUrl ? (
          <img
            src={admin.avatarUrl}
            alt={admin.userName}
            className={style.withAvatar}
          />
        ) : (
          <span
            className={style.avatarInitial}
            style={{ backgroundColor: avatarColor(admin.userName || '') }}
          >
            {initialOf(admin.userName || '')}
          </span>
        )}
        <h6 className={style.adminName}>{admin.userName}</h6>
      </div>
      <span
        className={style.emailCopy}
        role="button"
        tabIndex={0}
        title="Натисніть, щоб скопіювати"
        onClick={handleCopyEmail}
      >
        {copied ? (
          <span className={style.copiedText}>✓ Скопійовано</span>
        ) : (
          <span className={style.adminEmail}>{admin.email}</span>
        )}
        {!copied && admin.email && <CopyIcon />}
      </span>
      <button className={style.deleteButton} onClick={() => openModal(admin)}>
        <DeleteIcon />
      </button>
    </div>
  );
};

export default AdminItem;
